import * as React from 'react';

const ExampleSection: React.FC = () => {
  return (
    <div style={{
      padding: '70px 0',
      backgroundColor: '#f0f7ff',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Background Pattern */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        opacity: 0.04,
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ff5722' fill-opacity='0.1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
      }} />
      
      <div style={{ 
        maxWidth: '1200px', 
        margin: '0 auto', 
        textAlign: 'center',
        position: 'relative',
        zIndex: 1,
        padding: '0 20px'
      }}>
        <h2 style={{ 
          fontSize: '2.5rem', 
          fontWeight: 'bold', 
          marginBottom: '16px', 
          color: '#1f2937',
          background: 'linear-gradient(to right, #4f46e5, #7c3aed)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          display: 'inline-block'
        }}>
          Example Roasts
        </h2>
        <p style={{ 
          fontSize: '1.25rem', 
          color: '#4b5563', 
          marginBottom: '24px', 
          maxWidth: '800px', 
          margin: '0 auto 24px',
          fontWeight: 500
        }}>
          We don't just analyze listings, we verbally incinerate them with humor and actionable insights
        </p>
        <p style={{ 
          fontSize: '0.9rem', 
          color: '#6b7280', 
          marginBottom: '48px', 
          maxWidth: '800px', 
          margin: '0 auto 48px',
          fontStyle: 'italic'
        }}>
          (These are fictional examples to demonstrate our roasting style)
        </p>
        
        <div style={{ display: 'flex', flexDirection: 'column', gap: '32px' }}>
          <div style={{ 
            padding: '32px', 
            backgroundColor: 'white', 
            borderRadius: '12px', 
            boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)', 
            textAlign: 'left',
            border: '1px solid rgba(79, 70, 229, 0.1)',
            transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out'
          }}>
            <h3 style={{ 
              fontSize: '1.5rem', 
              fontWeight: 'bold', 
              marginBottom: '16px', 
              color: '#1f2937',
              display: 'flex',
              alignItems: 'center'
            }}>
              <span style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '32px',
                height: '32px',
                borderRadius: '50%',
                backgroundColor: '#4f46e5',
                color: 'white',
                fontSize: '1rem',
                marginRight: '12px'
              }}>1</span>
              Wireless Earbuds Listing
            </h3>
            <p style={{ 
              color: '#4b5563', 
              marginBottom: '20px',
              fontSize: '1.125rem',
              lineHeight: '1.7'
            }}>
              "Your earbuds listing has the appeal of a telemarketer calling during dinner. The title has fewer keywords than a mime has speaking lines, your product images look like they were taken by someone who just discovered what a camera is, and your bullet points are emptier than a politician's promises. If these earbuds sound half as bad as your listing reads, customers will need hearing aids after using them. But seriously, add competitor keywords, reshoot your main image, and focus on benefits, not just features."
            </p>
            <div style={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              alignItems: 'center',
              borderTop: '1px solid #e5e7eb',
              paddingTop: '16px'
            }}>
              <div style={{ 
                backgroundColor: '#fef2f2', 
                color: '#b91c1c', 
                padding: '6px 16px', 
                borderRadius: '9999px', 
                fontSize: '0.875rem', 
                fontWeight: 'bold',
                display: 'flex',
                alignItems: 'center'
              }}>
                <span style={{ marginRight: '4px' }}>🔥</span>
                Score: 63/100
              </div>
              <div style={{ 
                color: '#4b5563', 
                fontSize: '0.875rem',
                fontWeight: '500'
              }}>
                Try adding competitor keywords and better product dimensions
              </div>
            </div>
          </div>
          
          <div style={{ 
            padding: '32px', 
            backgroundColor: 'white', 
            borderRadius: '12px', 
            boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)', 
            textAlign: 'left',
            border: '1px solid rgba(79, 70, 229, 0.1)',
            transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out'
          }}>
            <h3 style={{ 
              fontSize: '1.5rem', 
              fontWeight: 'bold', 
              marginBottom: '16px', 
              color: '#1f2937',
              display: 'flex',
              alignItems: 'center'
            }}>
              <span style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '32px',
                height: '32px',
                borderRadius: '50%',
                backgroundColor: '#4f46e5',
                color: 'white',
                fontSize: '1rem',
                marginRight: '12px'
              }}>2</span>
              Organic Coffee Beans Listing
            </h3>
            <p style={{ 
              color: '#4b5563', 
              marginBottom: '20px',
              fontSize: '1.125rem',
              lineHeight: '1.7'
            }}>
              "Your coffee listing is almost as bitter as your product. While your images aren't terrible (congratulations on clearing that low bar), your description reads like it was written by someone who thinks 'organic' is a personality trait. Your bullet points drone on about 'premium quality' without explaining what that means - it's like a dating profile that just says 'I'm nice.' And that price point? Customers will need caffeine just to stay awake long enough to click away to your competitors. Try highlighting specific flavor notes, sourcing details, and why your coffee is actually worth that price."
            </p>
            <div style={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              alignItems: 'center',
              borderTop: '1px solid #e5e7eb',
              paddingTop: '16px'
            }}>
              <div style={{ 
                backgroundColor: '#ecfdf5', 
                color: '#047857', 
                padding: '6px 16px', 
                borderRadius: '9999px', 
                fontSize: '0.875rem', 
                fontWeight: 'bold',
                display: 'flex',
                alignItems: 'center'
              }}>
                <span style={{ marginRight: '4px' }}>🚀</span>
                Score: 82/100
              </div>
              <div style={{ 
                color: '#4b5563', 
                fontSize: '0.875rem',
                fontWeight: '500'
              }}>
                Consider highlighting specific flavor notes and origin details
              </div>
            </div>
          </div>
          
          <div style={{ 
            padding: '32px', 
            backgroundColor: 'white', 
            borderRadius: '12px', 
            boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)', 
            textAlign: 'left',
            border: '1px solid rgba(79, 70, 229, 0.1)',
            transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out'
          }}>
            <h3 style={{ 
              fontSize: '1.5rem', 
              fontWeight: 'bold', 
              marginBottom: '16px', 
              color: '#1f2937',
              display: 'flex',
              alignItems: 'center'
            }}>
              <span style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '32px',
                height: '32px',
                borderRadius: '50%',
                backgroundColor: '#4f46e5',
                color: 'white',
                fontSize: '1rem',
                marginRight: '12px'
              }}>3</span>
              Yoga Mat Listing
            </h3>
            <p style={{ 
              color: '#4b5563', 
              marginBottom: '20px',
              fontSize: '1.125rem',
              lineHeight: '1.7'
            }}>
              "This yoga mat listing needs more stretching than the customers who'll use it. Your title is so generic it could be for literally anything flat and rectangular. The product images have all the zen of a traffic jam, and your bullet points are so vague they could apply to a piece of cardboard. The only thing getting exercise here is my eye muscles from all the rolling they're doing. Namaste away from this listing unless you make some serious changes. Add thickness and material specs in the title, show lifestyle images of the mat in use, and specify exactly what makes your mat non-slip and eco-friendly."
            </p>
            <div style={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              alignItems: 'center',
              borderTop: '1px solid #e5e7eb',
              paddingTop: '16px'
            }}>
              <div style={{ 
                backgroundColor: '#fffbeb', 
                color: '#b45309', 
                padding: '6px 16px', 
                borderRadius: '9999px', 
                fontSize: '0.875rem', 
                fontWeight: 'bold',
                display: 'flex',
                alignItems: 'center'
              }}>
                <span style={{ marginRight: '4px' }}>⚠️</span>
                Score: 54/100
              </div>
              <div style={{ 
                color: '#4b5563', 
                fontSize: '0.875rem',
                fontWeight: '500'
              }}>
                Add material specs and show the mat in actual use scenarios
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExampleSection;
